import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  showRank?: boolean;
}

export default function ComicCard({ comic, showRank }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100 transition-all duration-300 group-hover:scale-[1.02]">
        {showRank && comic.rank <= 3 && (
          <div className="absolute top-2 left-2 z-10 w-7 h-7 flex items-center justify-center rounded-full bg-primary-500 text-white text-xs font-bold">
            {comic.rank}
          </div>
        )}
        <div className="relative w-full aspect-[3/4] overflow-hidden">
          <img
            src={comic.cover}
            alt={`${comic.title} - 香蕉文化漫画网`}
            title={`${comic.title} - 免费在线漫画阅读`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
            <span className="text-white text-xs font-medium bg-primary-500 px-2 py-1 rounded-md">
              立即阅读
            </span>
          </div>
          {comic.status === '已完结' && (
            <div className="absolute top-2 right-2 bg-accent-500 text-white text-xs px-2 py-0.5 rounded-full">
              完结
            </div>
          )}
          {comic.isNew && (
            <div className="absolute top-2 right-2 bg-secondary-500 text-white text-xs px-2 py-0.5 rounded-full">
              新作
            </div>
          )}
        </div>
        <div className="p-3">
          <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
            {comic.title}
          </h3>
          <p className="text-xs text-foreground-500 mt-1 truncate">{comic.author}</p>
          <div className="flex items-center gap-2 mt-2">
            <div className="flex items-center gap-0.5">
              <i className="ri-star-fill text-xs text-amber-400"></i>
              <span className="text-xs text-foreground-600">{comic.rating}</span>
            </div>
            <span className="text-xs text-foreground-400">|</span>
            <span className="text-xs text-foreground-500">{comic.tags[0]}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}